import { NavLink } from "react-router-dom";
import "burger-react/dist/style.css";

function Navbar() {


  return (
    <div className="bg-white md:absolute md:top-auto sm:fixed sm:top-0 w-full z-50 shadow-2xl">
      <div className="container mx-auto flex items-center md:justify-between sm:justify-between h-24">
        <div className="logo w-36">
          <a href="/">
            <img src="https://jedai.az/images/partners/2205050258.png" alt="" />
          </a>
        </div>

        <nav>
          <ul className="md:flex sm:hidden gap-x-6 list-square text-sm">
            <li>
              <NavLink
                className=" px-2 py-1 rounded-2xl"
                style={({ isActive }) => ({
                  color: isActive ? "white" : "black",
                  backgroundColor: isActive ? "#016B38" : "white",
                  transition: ".4s all ease",
                })}
                to="/"
              >
                Ana səhifə
              </NavLink>
            </li>
            <li>
              <NavLink
                className="px-2 py-1 rounded-2xl"
                style={({ isActive }) => ({
                  color: isActive ? "white" : "black",
                  backgroundColor: isActive ? "#016B38" : "white",
                  transition: ".4s all ease",
                })}
                to="/haqqimizda"
              >
                Haqqımızda
              </NavLink>
            </li>
            <li>
              <NavLink
                className="px-2 py-1 rounded-2xl"
                style={({ isActive }) => ({
                  color: isActive ? "white" : "black",
                  backgroundColor: isActive ? "#016B38" : "white",
                  transition: ".4s all ease",
                })}
                to="/layiheler"
              >
                Layihələr
              </NavLink>
            </li>
            <li>
              <NavLink
                className="px-2 py-1 rounded-2xl"
                style={({ isActive }) => ({
                  color: isActive ? "white" : "black",
                  backgroundColor: isActive ? "#016B38" : "white",
                  transition: ".4s all ease",
                })}
                to="/xidmetler"
              >
                Xidmətlər
              </NavLink>
            </li>
            <li>
              <NavLink
                className="px-2 py-1 rounded-2xl"
                style={({ isActive }) => ({
                  color: isActive ? "white" : "black",
                  backgroundColor: isActive ? "#016B38" : "white",
                  transition: ".4s all ease",
                })}
                to="/vakansiyalar"
              >
                Vakansiyalar
              </NavLink>
            </li>
            <li>
              <NavLink
                className="px-2 py-1 rounded-2xl"
                style={({ isActive }) => ({
                  color: isActive ? "white" : "black",
                  backgroundColor: isActive ? "#016B38" : "white",
                  transition: ".4s all ease",
                })}
                to="/xeberler"
              >
                Xəbərlər
              </NavLink>
            </li>
            <li>
              <NavLink
                className="px-2 py-1 rounded-2xl"
                style={({ isActive }) => ({
                  color: isActive ? "white" : "black",
                  backgroundColor: isActive ? "#016B38" : "white",
                  transition: ".4s all ease",
                })}
                to="/elaqe"
              >
                Əlaqə
              </NavLink>
            </li>
          </ul>
        </nav>        
      </div>
    </div>
  );
}

export default Navbar;
